import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PurchaseSelectModal from "../common/PurchaseSelectModal";
import PartnerUserSelectModal from "../common/PartnerUserSelectModal";
import ItemSelectModal from "../common/ItemSelectModal";
import UserSelectModal from "../common/UserSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

let newFileID = 1;
let realFiles = [];
function PurchaseRegModal({ title, onClose, handleRegSuccessSave, userTypeModalOption, unitCurrencyModalOption, MenuUpdateYN, payload}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    purchase_id: null,
    purchase_number: '',
    purchase_date: appStore.YYYY_MM_DD(),
    purchase_name: '',
    purchase_partner_id: 0,
    purchase_partner_name: '',
    purchase_partner_manager: '',
    purchase_partner_manager_phone: '',
    purchase_partner_manager_mail: '',
    purchase_bigo: '',
    purchase_ref_purchase_id: null,
  });
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectPurchaseModalOpen, setSelectPurchaseModalOpen] = useState(false);
  const [isSelectPartnerModalOpen, setSelectPartnerModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectUserData, setSelectUserData] = useState('');
  const [upperPartnerId, setUpperPartnerId] = useState(0);

  const handleSetting = () => {
    setItemColumns([
      {
          field: 'actions',
          headerName: '동작',
          width: 55,
          type:'actions',
          disableClickEventBubbling: true,
          getActions: (params) => [
              ((params.row.update_type === "U")? 
              <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
              : (params.row.row_type === "A" && params.row.update_type === "N")? 
              <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {itemAddClick(params)}} label="Add"  /> 
              :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
              )
            ],
          headerAlign: 'center', 
          align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'purchase_item_id', headerName: 'purchase_item_id', headerAlign: 'center', align:'center' },
      { field: 'purchase_item_name', headerName: '품목', width: 190, headerAlign: 'center', align:'left' },
      { field: 'purchase_item_count', headerName: '발주수량', type: 'number', width: 100, headerAlign: 'center', align:'right', editable: true },
      { field: 'purchase_item_price_currency', headerName: '통화단위', type: 'singleSelect', width: 90, 
        valueOptions: () => unitCurrencyModalOption ?? [], valueFormmatter: ({  value }) => 
          unitCurrencyModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'purchase_item_price', headerName: '단가', type: 'number',width: 100, headerAlign: 'center', type: 'number', editable: true},
      { field: 'purchase_item_sv_price', headerName: '공급가액', type: 'number', width: 110, headerAlign: 'center', align:'right', editable: true },
      { field: 'purchase_item_vat_price', headerName: '부가세액', type: 'number',width: 110, headerAlign: 'center', align:'right', editable: true },
      { field: 'purchase_item_total_price', headerName: '합계금액', type: 'number',width: 120, headerAlign: 'center', align:'right' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'purchase_user_id', headerName: 'purchase_user_id', width: 0, headerAlign: 'center' },
      { field: 'purchase_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'purchase_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'purchase_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'purchase_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'purchase_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setItemColumnVisibilityModel({
      id: false,
      actions: true,
      purchase_item_id: false,
      purchase_item_name: true,
      purchase_item_count: true,
      purchase_item_price_currency: true,
      purchase_item_price: true,
      purchase_item_sv_price: true,
      purchase_item_vat_price: true,
      purchase_item_total_price: true,
      row_type: false,
      update_type: false
    });

    setUserColumnVisibilityModel({
      id: false,
      actions: true,
      purchase_user_id: false,
      purchase_user_name: true,
      purchase_user_dept_name: true,
      purchase_user_position_name: true,
      purchase_user_type: true,
      purchase_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: true,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: (MenuUpdateYN==='Y')?true:false,
    purchase_item_id: false,
    purchase_item_name: true,
    purchase_item_count: true,
    purchase_item_price_currency: true,
    purchase_item_price: true,
    purchase_item_sv_price: true,
    purchase_item_vat_price: true,
    purchase_item_total_price: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: (MenuUpdateYN==='Y')?true:false,
    purchase_user_id: false,
    purchase_user_name: true,
    purchase_user_dept_name: true,
    purchase_user_position_name: true,
    purchase_user_type: true,
    purchase_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: (MenuUpdateYN==='Y')?true:false,
    download: true,
    row_type: false,
    update_type: false
  });

  // ✅ 엑셀 데이터가 payload로 넘어왔을 때 값을 채워넣고 금액 자동 계산하는 로직
  useEffect(() => {
    if (payload && (payload.from === 'excel_upload' || payload.from === 'excel_dragdrop') && payload.uploadResult) {
      const data = payload.uploadResult;

      setInputs(prev => ({
        ...prev,
        purchase_name: data.purchase_name || data.order_name || '',
        purchase_date: data.purchase_date || data.order_date || appStore.YYYY_MM_DD(),
        purchase_partner_id: Number(data.partner_id) || 0,
        purchase_partner_name: data.partner_name || '',
        purchase_partner_manager: data.partner_manager || '',
        purchase_partner_manager_mail: data.partner_manager_mail || '',
        purchase_partner_manager_phone: data.partner_manager_phone || '',
        purchase_bigo: data.remark || '',
      }));

      if (data.items && data.items.length > 0) {
        const validItems = data.items.filter(it => it.item_id || it.item_name);
        const parsedItems = validItems.map((it, idx) => {
          const qty = Number(it.qty) || 0;
          const price = Number(it.price) || 0;
          const supplyPrice = Number(it.supply) || (qty * price);
          const vatPrice = Number(it.vat) || Math.floor(supplyPrice * 0.1);
          const totalPrice = supplyPrice + vatPrice;

          return {
            id: idx + 1,
            purchase_item_id: it.item_id || '',
            purchase_item_name: it.item_name || '',
            purchase_item_count: qty,
            purchase_item_price_currency: 144, // 기본값
            purchase_item_price: price,
            purchase_item_sv_price: supplyPrice,
            purchase_item_vat_price: vatPrice,
            purchase_item_total_price: totalPrice,
            row_type: 'A',
            update_type: 'U'
          };
        });
        setItemRows(parsedItems);
        setUpdateItemRows(parsedItems);
      }

      if (data.users && data.users.length > 0) {
        const validUsers = data.users.filter(u => u.user_id || u.user_name);
        const parsedUsers = validUsers.map((u, idx) => ({
          id: idx + 1,
          purchase_user_id: u.user_id || '',
          purchase_user_name: u.user_name || '',
          purchase_user_type: Number(u.user_type_id) || 0,
          purchase_user_dept_name: u.user_dept_name || '',
          purchase_user_position_name: u.user_position_name || '',
          purchase_user_bigo: u.remark || '',
          row_type: 'A',
          update_type: 'U'
        }));
        setUserRows(parsedUsers);
        setUpdateUserRows(parsedUsers);
      }
    }
  }, [payload]);

  useEffect(() => {
      // Mount 될때만 실행된다.
      realFiles = [];
      handleSetting();
      setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<itemRows.length; i++){
      if(itemRows[i].row_type === 'A' && itemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        purchase_item_id: '',
        purchase_item_name: '',
        purchase_item_count: '',
        purchase_item_price_currency: 144,
        purchase_item_price: 0,
        purchase_item_sv_price: 0,
        purchase_item_vat_price: 0,
        purchase_item_total_price: 0,
        row_type:'A',
        update_type: 'N'
      }]);
    }
    
  }, [itemRows]);
  
  useEffect(() => {
    // userRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        purchase_user_id: '',
        purchase_user_name: '',
        purchase_user_dept_name: '',
        purchase_user_position_name: '',
        purchase_user_type: 0,
        purchase_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  useEffect(() => {
    let ADD_YN= 'Y'
    var array = [];
    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){
        array.push({
          id: newFileID,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_name: tmp_file_name,
          file_type_name: tmp_file_type_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_reg_user_name,
          reg_datetime: tmp_reg_datetime,
          row_type:tmp_row_type,
          update_type: tmp_update_type
        })
        newFileID = newFileID + 1;
      }
    }
    setUpdateFileRows(array);
    
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(appStore.getMaxListID(fileRows))+1,
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onClick = (e)=>{ // inputs 데이터 품목 text 클릭시

    setSelectModalTitle('발주처 목록')
    setSelectPartnerModalOpen(true);
    
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onHypenChange = (e)=>{
    const {name, value} = e.target;
    var hyphen_data = ''
    if(e.target.name === 'purchase_partner_manager_phone'){ // 전화번호인 경우
        hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processItemRowUpdate = (newRow, oldRow) => {
    if(newRow.purchase_item_count > 99999){
      return;
    }
    //발주 품목 Rows Update

    // 합계금액은 자동으로 계산 (발주수량 x (공급가액+부가세액))
    // 날짜형식 fomat 맞춰주기
    /*
    const newUpdateDataArray = { 
        ...newRow
        , ['purchase_item_total_price']: newRow.purchase_item_count * (newRow.purchase_item_sv_price + newRow.purchase_item_vat_price)
        , ['real_purchase_item_delivery_date']: (newRow.purchase_item_delivery_date === ''?'':Moment(newRow.purchase_item_delivery_date).format('YYYY-MM-DD'))
        , update_type: 'U' }; // 값 변경이 있는 경우
    */
    // 02/24 추가 
    // 공급가액 ==> 단가 * 수량
    // 부가세액 ==> 공급가액 / 10
    // 합계금액 ==> 공급가액 + 부가세액
    // case --> 수량이 바뀐경우 / 단가가 바뀐경우 / 공급가액을 수정한 경우 / 부가세액을 수정한 경우
    if(oldRow.purchase_item_id !== newRow.purchase_item_id || oldRow.purchase_item_name !== newRow.purchase_item_name || oldRow.purchase_item_count !== newRow.purchase_item_count || oldRow.purchase_item_price !== newRow.purchase_item_price || oldRow.purchase_item_sv_price !== newRow.purchase_item_sv_price || oldRow.purchase_item_vat_price !== newRow.purchase_item_vat_price){
      let newUpdateDataArray = {}
      const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; // 값 변경이 없는 경우
      
      if (newRow.purchase_item_count !== oldRow.purchase_item_count){ // 수량이 바뀐경우
        newUpdateDataArray = { 
          ...newRow
          , ['purchase_item_sv_price']: newRow.purchase_item_count * (newRow.purchase_item_price)
          , ['purchase_item_vat_price']: (newRow.purchase_item_count * (newRow.purchase_item_price))/10
          , ['purchase_item_total_price']: newRow.purchase_item_count * (newRow.purchase_item_price) + ((newRow.purchase_item_count * (newRow.purchase_item_price))/10)
          , update_type: 'U' }; // 값 변경이 있는 경우
      } else if (newRow.purchase_item_price !== oldRow.purchase_item_price) { // 단가가 바뀐경우
        newUpdateDataArray = { 
          ...newRow
          , ['purchase_item_sv_price']: newRow.purchase_item_count * (newRow.purchase_item_price)
          , ['purchase_item_vat_price']: (newRow.purchase_item_count * (newRow.purchase_item_price))/10
          , ['purchase_item_total_price']: newRow.purchase_item_count * (newRow.purchase_item_price) + ((newRow.purchase_item_count * (newRow.purchase_item_price))/10)
          , update_type: 'U' }; // 값 변경이 있는 경우
      } else if (newRow.purchase_item_sv_price !== oldRow.purchase_item_sv_price) { // 공급가액을 수정한 경우
        newUpdateDataArray = { 
          ...newRow
          , ['purchase_item_vat_price']: (newRow.purchase_item_sv_price/10)
          , ['purchase_item_total_price']: newRow.purchase_item_sv_price+(newRow.purchase_item_sv_price/10)
          , update_type: 'U' }; // 값 변경이 있는 경우
      } else if (newRow.purchase_item_vat_price !== oldRow.purchase_item_vat_price) { // 부가세액을 수정한 경우
        newUpdateDataArray = { 
          ...newRow
          , ['purchase_item_total_price']: newRow.purchase_item_sv_price + newRow.purchase_item_vat_price
          , update_type: 'U' }; // 값 변경이 있는 경우
      } else { // 품목 또는 통화 변경이 있는 경우
        newUpdateDataArray = { ...newRow, update_type: 'U' }; 
      }
      
      var row_purchase_item_id = '';
      var row_purchase_item_name = '';
      var row_purchase_item_count = '';
      var row_purchase_item_price_currency = 144;
      var row_purchase_item_price = 0;
      var row_purchase_item_sv_price = 0;
      var row_purchase_item_vat_price = 0;
      var row_purchase_item_total_price = 0;

      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.purchase_item_id !== '' || newRow.purchase_item_name !== '' || newRow.purchase_item_count !== ''
          || newRow.purchase_item_price_currency !== 144 || newRow.purchase_item_price !== 0 || newRow.purchase_item_sv_price !== 0
          || newRow.purchase_item_vat_price !== 0 || newRow.purchase_item_total_price !== 0){
          row_purchase_item_id = newRow.purchase_item_id;
          row_purchase_item_name = newRow.purchase_item_name;
          row_purchase_item_count = newRow.purchase_item_count;
          row_purchase_item_price_currency = newRow.purchase_item_price_currency;
          row_purchase_item_price = newRow.purchase_item_price;
          row_purchase_item_sv_price = newRow.purchase_item_sv_price;
          row_purchase_item_vat_price = newRow.purchase_item_vat_price;
          row_purchase_item_total_price = newRow.purchase_item_total_price;
        
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        itemRows.map((data) => data.id === newRow.id 
          && (data.purchase_item_id !== newRow.purchase_item_id || data.purchase_item_name !== newRow.purchase_item_name || data.purchase_item_count !== newRow.purchase_item_count
            || data.purchase_item_price_currency !== newRow.purchase_item_price_currency || data.purchase_item_price !== newRow.purchase_item_price
            || data.purchase_item_sv_price !== newRow.purchase_item_sv_price || data.purchase_item_vat_price !== newRow.purchase_item_vat_price
            || data.purchase_item_total_price !== newRow.purchase_item_total_price)?
          (
            row_purchase_item_id = data.purchase_item_id,
            row_purchase_item_name = data.purchase_item_name,
            row_purchase_item_count = data.purchase_item_count,
            row_purchase_item_price_currency = data.purchase_item_price_currency,
            row_purchase_item_price = data.purchase_item_price,
            row_purchase_item_sv_price = data.purchase_item_sv_price,
            row_purchase_item_vat_price = data.purchase_item_vat_price,
            row_purchase_item_total_price = data.purchase_item_total_price
          ):""
        )
      }
      
      if(row_purchase_item_id === '' && row_purchase_item_name === '' && row_purchase_item_count === '' 
        && row_purchase_item_price_currency === 144 && row_purchase_item_price === 0 && row_purchase_item_sv_price === 0 && row_purchase_item_vat_price === 0
        && row_purchase_item_total_price === 0){
        // 1. 값이 수정되지 않은 경우.
        if(updateItemRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateItemRows.length);
          setUpdateItemRows(updateItemRows.filter((data) => data.id !== newRow.id));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateItemRows.length; i++) {
          if(updateItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateItemRows.length);
          setUpdateItemRows(updateItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateItemRows.length);
          setUpdateItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    //담당자 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우
  
    if(oldRow.purchase_user_id !== newRow.purchase_user_id || oldRow.purchase_user_type !== newRow.purchase_user_type || oldRow.purchase_user_bigo !== newRow.purchase_user_bigo){
      var row_purchase_user_id = '';
      var row_purchase_user_name = '';
      var row_purchase_user_type = 0;
      var row_purchase_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if(newRow.purchase_user_id !== '' || newRow.purchase_user_name !== '' || (newRow.purchase_user_type !== 0 && newRow.purchase_user_type !== '') || newRow.purchase_user_bigo !== '' ){
          row_purchase_user_id = newRow.purchase_user_id;
          row_purchase_user_name = newRow.purchase_user_name;
          row_purchase_user_type = newRow.purchase_user_type;
          row_purchase_user_bigo = newRow.purchase_user_bigo;
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        userRows.map((data) => data.id === newRow.id 
          && (data.purchase_user_id !== newRow.purchase_user_id || data.purchase_user_name !== newRow.purchase_user_name || data.purchase_user_type !== newRow.purchase_user_type || data.purchase_user_bigo !== newRow.purchase_user_bigo )?
          (
            row_purchase_user_id = data.purchase_user_id,
            row_purchase_user_name = data.purchase_user_name,
            row_purchase_user_type = data.purchase_user_type,
            row_purchase_user_bigo = data.purchase_user_bigo
          ):""
        )
      }
      
      if(row_purchase_user_id === '' && row_purchase_user_name === '' && row_purchase_user_bigo === '' && (row_purchase_user_type === 0 || row_purchase_user_type === null)){
        // 1. 값이 수정되지 않은 경우.
        if(updateUserRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          //console.log('[updateRows 원복] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateUserRows.length);
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateUserRows.length);
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const itemAddClick = (object) => {
    //발주 품목 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        purchase_item_id: '',
        purchase_item_name: '',
        purchase_item_count: '',
        purchase_item_price_currency: 144,
        purchase_item_price: 0,
        purchase_item_sv_price: 0,
        purchase_item_vat_price: 0,
        purchase_item_total_price: 0,
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: object.row.id,
        purchase_item_id: object.row.purchase_item_id,
        purchase_item_name: object.row.purchase_item_name,
        purchase_item_count: object.row.purchase_item_count,
        purchase_item_price_currency: object.row.purchase_item_price_currency,
        purchase_item_price: object.row.purchase_item_price,
        purchase_item_sv_price: object.row.purchase_item_sv_price,
        purchase_item_vat_price: object.row.purchase_item_vat_price,
        purchase_item_total_price: object.row.purchase_item_total_price,
        row_type: object.row.row_type,
        update_type: object.row.update_type,
      })
    }
  };

  const itemDeleteClick = (object) => {
    //발주 품목 삭제 버튼
    setUpdateItemRows((updateItemRows) => updateItemRows.filter((data) => data.id !== object.row.id));
    setItemRows((itemRows) => itemRows.filter((data) => data.id !== object.row.id));
  };

  const userAddClick = (object) => {
    //발주 담당자 추가 버튼
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        purchase_user_id: '',
        purchase_user_name: '',
        purchase_user_dept_name: '',
        purchase_user_position_name: '',
        purchase_user_type: 0,
        purchase_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: object.row.id,
        purchase_user_id: object.row.purchase_user_id,
        purchase_user_name: object.row.purchase_user_name,
        purchase_user_dept_name: object.row.purchase_user_dept_name,
        purchase_user_position_name: object.row.purchase_user_position_name,
        purchase_user_type: object.row.purchase_user_type,
        purchase_user_bigo: object.row.purchase_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    //발주 담당자 삭제 버튼
    setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };
  
  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.click();
    input.onchange = () => {

      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
      }
      
      var array = [];
      for(var i=0; i<realFiles.length; i++){
        var tmp_sever_file_name = realFiles[i].name;
        var tmp_file_name = realFiles[i].name;
        var tmp_file_size = realFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(realFiles[i].size);
        var tmp_file_type = realFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(realFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);

        array.push({
          id: newFileID,
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        })
        newFileID = newFileID + 1;
      }
      setFileRows(array);
    }
  };

  const fileDeleteClick = (object) => {
    //파일 삭제 버튼
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }
    setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
    //파일 다운로드
  }

  const handlePurchaseRef = (event) => {
    // 발주 참조를 위한 발주조회
    setSelectModalTitle('발주 목록')
    setSelectPurchaseModalOpen(true);
  }

  const handleOnCellClick = (params) => {
    if(params.field === 'purchase_item_name'){
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: params.row.id,
        purchase_item_id: params.row.purchase_item_id,
        purchase_item_name: params.row.purchase_item_name,
        purchase_item_count: params.row.purchase_item_count,
        purchase_item_price_currency: params.row.purchase_item_price_currency,
        purchase_item_price: params.row.purchase_item_price,
        purchase_item_sv_price: params.row.purchase_item_sv_price,
        purchase_item_vat_price: params.row.purchase_item_vat_price,
        purchase_item_total_price: params.row.purchase_item_total_price,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.field === 'purchase_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        purchase_user_id: params.row.purchase_user_id,
        purchase_user_name: params.row.purchase_user_name,
        purchase_user_dept_name: params.row.purchase_user_dept_name,
        purchase_user_position_name: params.row.purchase_user_position_name,
        purchase_user_type: params.row.purchase_user_type,
        purchase_user_bigo: params.row.purchase_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    }
  };

  const handlePurchaseClick = (object) => {
    //발주조회에서 클릭한 값으로 전체 데이터 참조값으로 변경
    if(object.length !== 0){
      
      Swal.fire({
        title: '발주번호 '+object[0].purchase_number+' 복사',
        text: '확인버튼을 클릭하면 발주가 복사됩니다',
        showCancelButton: true,
        confirmButtonText: '확인', 
        cancelButtonText: '취소',
        confirmButtonColor: '#0067a3',
        cancelButtonColor: '#d33',
      }).then(result => {
          if (result.isConfirmed) {
            setInputs({
              purchase_id: null,
              purchase_number: '',
              purchase_date: appStore.YYYY_MM_DD(),
              purchase_name: object[0].purchase_name,
              purchase_partner_id: Number(object[0].purchase_partner_id),
              purchase_partner_name: object[0].purchase_partner_name,
              purchase_partner_manager: object[0].purchase_partner_manager,
              purchase_partner_manager_phone: object[0].purchase_partner_manager_phone,
              purchase_partner_manager_mail: object[0].purchase_partner_manager_mail,
              purchase_bigo: object[0].purchase_bigo,
              purchase_ref_purchase_id: Number(object[0].purchase_id),
            });
        
            var itemData = object.filter((item, index) => {
              return (
                object.findIndex((item2, index2) => {
                  return typeof item.purchase_item_seq !== 'undefined' && item.purchase_item_seq === item2.purchase_item_seq;
                }) === index
              );
            });
        
            setItemRows(itemData.map((item, index) => ({
              id: item.purchase_item_seq,
              purchase_item_id: item.purchase_item_id,
              purchase_item_name: item.purchase_item_name,
              purchase_item_count: item.purchase_item_count,
              purchase_item_price_currency: item.purchase_item_price_currency,
              purchase_item_price: item.purchase_item_price,
              purchase_item_sv_price: item.purchase_item_sv_price,
              purchase_item_vat_price: item.purchase_item_vat_price,
              purchase_item_total_price: item.purchase_item_total_price,
              row_type: 'A',
              update_type: 'U'
            })));

            setUpdateItemRows(itemData.map((item, index) => ({
              id: item.purchase_item_seq,
              purchase_item_id: item.purchase_item_id,
              purchase_item_name: item.purchase_item_name,
              purchase_item_count: item.purchase_item_count,
              purchase_item_price_currency: item.purchase_item_price_currency,
              purchase_item_price: item.purchase_item_price,
              purchase_item_sv_price: item.purchase_item_sv_price,
              purchase_item_vat_price: item.purchase_item_vat_price,
              purchase_item_total_price: item.purchase_item_total_price,
              row_type: 'A',
              update_type: 'U'
            })));

            var userData = object.filter((item, index) => {
              return (
                object.findIndex((item2, index2) => {
                  return typeof item.purchase_user_seq !== 'undefined' && item.purchase_user_seq === item2.purchase_user_seq;
                }) === index
              );
            });
        
            setUserRows(userData.map((item, index) => ({
              id: item.purchase_user_seq,
              purchase_user_id: item.purchase_user_id,
              purchase_user_name: item.purchase_user_name,
              purchase_user_dept_name: item.purchase_user_dept_name,
              purchase_user_position_name: item.purchase_user_position_name,
              purchase_user_type: item.purchase_user_type,
              purchase_user_bigo: item.purchase_user_bigo,
              row_type: 'A',
              update_type: 'U'
            })));

            setUpdateUserRows(userData.map((item, index) => ({
              id: item.purchase_user_seq,
              purchase_user_id: item.purchase_user_id,
              purchase_user_name: item.purchase_user_name,
              purchase_user_dept_name: item.purchase_user_dept_name,
              purchase_user_position_name: item.purchase_user_position_name,
              purchase_user_type: item.purchase_user_type,
              purchase_user_bigo: item.purchase_user_bigo,
              row_type: 'A',
              update_type: 'U'
            })));

          } else if (result.isDismissed) {
            const nextInputs = {
                ...inputs,
                ["purchase_ref_purchase_id"]: null,
            };
            setInputs(nextInputs);
          }

      })
    }else{
      setInputs({
        purchase_id: null,
        purchase_number: '',
        purchase_date: appStore.YYYY_MM_DD(),
        purchase_name: '',
        purchase_partner_id: 0,
        purchase_partner_name: '',
        purchase_partner_manager: '',
        purchase_partner_manager_phone: '',
        purchase_partner_manager_mail: '',
        purchase_bigo: '',
        purchase_ref_purchase_id: null,
      });

      setItemRows([]);
      setUpdateItemRows([]);
      setUserRows([]);
      setUpdateUserRows([]);
    }
  };

  const handlePartnerUserClick = (object) => {
    //발주처 모달에서 클릭한 값으로 발주처 및 담당자 데이터 설정함.
    var partner_user_name = object.partner_user_name === undefined?'':object.partner_user_name
    var partner_user_phone = object.partner_user_phone === undefined?'':object.partner_user_phone
    var partner_user_email = object.partner_user_email === undefined?'':object.partner_user_email

    const nextInputs = {
        ...inputs,
        ["purchase_partner_id"]: object.id,
        ["purchase_partner_name"]: object.partner_name,
        ["purchase_partner_manager"]: partner_user_name,
        ["purchase_partner_manager_phone"]: partner_user_phone,
        ["purchase_partner_manager_mail"]: partner_user_email,
        ["purchase_ref_purchase_id"]: null
    };
    setInputs(nextInputs);
    setUpperPartnerId(object.id);
  };
  
  const handleInputItemClick = (object) => {
    //품목 목록 모달에서 클릭한 값으로 발주 품목 데이터 설정함.
    var doubleYN = 'N'
    for(let i = 0; i < itemRows.length; i++){
      if(itemRows[i].purchase_item_id === object.id && selectItemData.id !== itemRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">품목 '+object.item_name+' 중복</p>',
        text: '추가된 품목이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectItemData.purchase_item_id){
        var item_real_price = 0; // 실단가
        if(object.partner_id === inputs.purchase_partner_id && object.item_in_out_type === 'I' && object.item_partner_price !== undefined){
          item_real_price = object.item_partner_price; // 선택되어 있는 발주처의 설정가격
        } else {
          item_real_price = object.item_stock_price; // 해당사항 없으면 품목의 단가 기본정보
        }
        processItemRowUpdate(
          {
            id: selectItemData.id,
            purchase_item_id: object.id,
            purchase_item_name: object.item_name + ' ' +appStore.ITEM_FULL_SPEC_MAKE( object.item_spec, object.item_width, object.item_depth, object.item_height),
            purchase_item_count: selectItemData.purchase_item_count,
            purchase_item_price_currency: object.item_stock_price_currency,
            purchase_item_price: item_real_price,
            purchase_item_sv_price: item_real_price,
            purchase_item_vat_price: selectItemData.purchase_item_vat_price,
            purchase_item_total_price: selectItemData.purchase_item_total_price,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          },
          {
            id: selectItemData.id,
            purchase_item_id: selectItemData.purchase_item_id,
            purchase_item_name: selectItemData.purchase_item_name,
            purchase_item_count: selectItemData.purchase_item_count,
            purchase_item_price_currency: selectItemData.purchase_item_price_currency,
            purchase_item_price: selectItemData.purchase_item_price,
            purchase_item_sv_price: selectItemData.purchase_item_sv_price,
            purchase_item_vat_price: selectItemData.purchase_item_vat_price,
            purchase_item_total_price: selectItemData.purchase_item_total_price,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          }
        )
      }
    }
  };

  const handleUserClick = (object) => {
    //사용자목록 모달에서 클릭한 값으로 담당자 데이터 설정함.
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].purchase_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.purchase_user_id){
        
        processUserRowUpdate(
          {
            id : selectUserData.id,
            purchase_user_id: object.id,
            purchase_user_name: object.user_name,
            purchase_user_dept_name: object.dept_name,
            purchase_user_position_name: object.position_name,
            purchase_user_type: selectUserData.purchase_user_type,
            purchase_user_bigo: selectUserData.purchase_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            purchase_user_id: selectUserData.purchase_user_id,
            purchase_user_name: selectUserData.purchase_user_name,
            purchase_user_type: selectUserData.purchase_user_type,
            purchase_user_dept_name: selectUserData.purchase_user_dept_name,
            purchase_user_position_name: selectUserData.purchase_user_position_name,
            purchase_user_bigo: selectUserData.purchase_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';
    if(inputs.purchase_name.trim() === '' || inputs.purchase_name.trim() === 0){
      msg = '발주명은 필수 입력 입니다.'
    }else if((inputs.purchase_date) === '' || (inputs.purchase_date) < '2025-01-01' || (inputs.purchase_date).length != 10){
      msg = '발주일자 입력이 올바르지 않습니다.<br/>(입력 양식 : 2025-01-01 ~ )'
    }else if(inputs.purchase_partner_id === '' || inputs.purchase_partner_id === 0){
      msg = '발주처는 필수 입력 입니다.'
    }else if(inputs.purchase_partner_manager_phone.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.purchase_partner_manager_phone.trim())){
      msg = '담당자 휴대번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자3,4자리-숫자4자리)';
    }else if(inputs.purchase_partner_manager_mail.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.purchase_partner_manager_mail.trim())){
      msg = '담당자 E-Mail 입력이 올바르지 않습니다.';
    }

    if(msg === '' && updateItemRows.length === 0){ // 발주품목이 0개 일 경우

      msg = '발주 품목이 존재하지 않습니다.';

    }else if(msg === '' && updateItemRows.length > 0){ // 발주품목 검사
      for(let i = 0; i < updateItemRows.length; i++) {
        const purchase_item_id = updateItemRows[i].purchase_item_id;
        const purchase_item_count = updateItemRows[i].purchase_item_count;
        const purchase_item_price_currency = updateItemRows[i].purchase_item_price_currency;
        const purchase_item_sv_price = updateItemRows[i].purchase_item_sv_price;
        const purchase_item_vat_price = updateItemRows[i].purchase_item_vat_price;

        if(purchase_item_id === 0 || purchase_item_id === '') {
          msg = '선택되지 않는 발주 품목이 존재합니다.';
          break;
        }
        if(purchase_item_count === 0 || purchase_item_count === '' || purchase_item_count === null) {
          msg = '입력되지 않는 발주 수량이 존재합니다.';
          break;
        }
        if(purchase_item_count < 0) {
          msg = '발주 수량은 음수가 될 수 없습니다.';
          break;
        }
        if(purchase_item_price_currency === 0 || purchase_item_price_currency === '') {
          msg = '선택되지 않는 통화단위가 존재합니다.';
          break;
        }
        if(purchase_item_sv_price !== "" && purchase_item_sv_price < 0) {
          msg = '공급가액은 음수가 될 수 없습니다.';
          break;
        }
        if(purchase_item_vat_price !== "" && purchase_item_vat_price < 0) {
          msg = '부가세액은 음수가 될 수 없습니다.';
          break;
        }
      }
    }

    // 발주담당자 검사
    if(msg === '' && updateUserRows.length > 0){
      for(let i = 0; i < updateUserRows.length; i++) {
        const purchase_user_id = updateUserRows[i].purchase_user_id;
        const purchase_user_type = updateUserRows[i].purchase_user_type;
        
        if(purchase_user_id === 0 || purchase_user_id === '') {
          msg = '선택되지 않는 담당자명이 존재합니다.';
          break;
        }
        if(purchase_user_type === 0 || purchase_user_type === '') {
          msg = '선택되지 않는 담당자유형이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">발주 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/Purchase/Reg", {inputs, updateItemRows, updateUserRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){
          
          var selectID = response.data;
          if(updateFileRows.length > 0) {

            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'Purchase');
            formData.append('type', 'Reg');
            formData.append('updateFileRows', JSON.stringify(updateFileRows));
            
            for(var i=0; i<realFiles.length; i++){            
              formData.append('files', realFiles[i]);
            }
            
            axios.post('/api/SaveCommon/GridFileSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            }).then(response => {
              handleRegSuccessSave(selectID);
            }).catch(error => {
              appStore.capture();
            });

          }else{

            handleRegSuccessSave(selectID);

          }

        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
        appStore.capture();
      })
      .finally(() => {
        appStore.setLoading(false); 
      });
    }
  };
  
  
  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="발주 정보" value="1" />
                <Tab label="발주 품목" value="2" />
                <Tab label="발주 담당자" value="3" />
                <Tab label="발주 파일" value="4" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">발주명<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="발주명" value={inputs.purchase_name} name="purchase_name" onChange={(e) => onChange(e) } autoComplete="off"/>
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">발주번호</div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="발주번호" value={inputs.purchase_number} name="purchase_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true}  style={ { fontWeight:'bold', color: 'black' } } />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">발주일자<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="date" placeholder="발주일자" value={inputs.purchase_date} name="purchase_date" onChange={(e) => onDateChange(e) } autoComplete="off"/>
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">발주처<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="발주처" value={inputs.purchase_partner_name} name="purchase_partner_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{backgroundColor: '#EFEFEF4D', fontWeight:'bold', color: 'black', cursor: 'pointer'}} readOnly />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">발주처 담당자</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                          <input type="text" placeholder="이름" value={inputs.purchase_partner_manager} name="purchase_partner_manager" onChange={(e) => onChange(e) } style={{ float: 'left', width: '112px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="휴대폰번호" value={inputs.purchase_partner_manager_phone} name="purchase_partner_manager_phone" onChange={(e) => onHypenChange(e) } style={{ float: 'left', width: '300px', marginRight: '15px' }} autoComplete="off" />
                          <input type="text" placeholder="메일주소" value={inputs.purchase_partner_manager_mail} name="purchase_partner_manager_mail" onChange={(e) => onChange(e) } style={{width: '360px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="비고" name="purchase_bigo" value={inputs.purchase_bigo} onChange={(e) => onChange(e) } style={{width: '768px', height: '200px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell'
                  processRowUpdate={processItemRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button" style={{float: 'left'}}>
                      <Button 
                        onClick={ handlePurchaseRef }
                        className="btn-p btn-u"
                        style={{width: '130px'}}
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#0067a3", 
                            backgroundColor: "#0067a3",
                            ":hover": { boxShadow: "2px 2px 2px #0067a3" , backgroundColor: "#0067a3", borderColor: "#0067a3"}
                        }} 
                        variant="outlined">
                        발주조회
                      </Button>
                    </div>
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    <div className="modal_button">
                      {MenuUpdateYN === 'Y' &&
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                      </Button> }
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {isSelectPurchaseModalOpen && (<PurchaseSelectModal
          onClose={() => {
              setSelectPurchaseModalOpen(false);
          }}
          title={selectmodalTitle}
          openType={'Purchase'}
          handlePurchaseClick={handlePurchaseClick}
          />)}
        {isSelectPartnerModalOpen && (<PartnerUserSelectModal
          onClose={() => {
              setSelectPartnerModalOpen(false);
          }}
          title={selectmodalTitle}
          handlePartnerUserClick={handlePartnerUserClick}
          />)}

        {isSelectItemModalOpen && (<ItemSelectModal
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          upperPartnerId={upperPartnerId}
          nowIOType={'I'}
          handleInputItemClick={handleInputItemClick}
          />)}

        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </PCModal>
  );
}

export default PurchaseRegModal;